/**@flow */

import { all, call, put, takeLatest } from "redux-saga/effects";
import { Impersonate } from "../constants/actions";
import actionCreators from "../actionCreator";
import type { Action } from "redux-action";
import http from "@http";
import { onCheckLogin } from "./index";
import LocalStorageService from "../../../services/LocalStorageService";

type ImpersonateRequest = $Exact<{
  clientId: number,
  employeeId: number,
}>;

export function* onImpersonate({ payload }: Action<ImpersonateRequest>): Generator<*, void, void> {
  try {
    if (!payload || !payload.clientId || !payload.employeeId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `/api/v1/employee-admin/client/${payload.clientId}/employee/${payload.employeeId}/impersonate`,
    );

    if (response && response.data) {
      LocalStorageService.setToken({
        token: response.data.accessToken,
        refreshToken: response.data.refreshToken,
      });
      LocalStorageService.setImpersonate();
    }

    yield all([put(actionCreators.ImpersonateSuccess()), call(onCheckLogin)]);
  } catch (e) {
    yield put(actionCreators.ImpersonateError(e.response));
  }
}

export function* impersonateSaga(): Generator<*, void, void> {
  yield all([takeLatest(Impersonate, onImpersonate)]);
}

export default impersonateSaga;
